import { useState, useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

const SearchBarProject = ({ showType }) => {
  const [searchParams, setSearchParams] = useSearchParams();
  
  const [query, setQuery] = useState(searchParams.get("query") || "");

  useEffect(() => {
    if (query.trim() === "") {
      searchParams.delete("query");
    } else {
      searchParams.set("query", query);
    }
    setSearchParams(searchParams, { replace: true });
  }, [query, setSearchParams]);

  return (
    <div className="blog-sidebar d-flex justify-content-center">
      <div className="widget search-widget col-12 col-md-6 col-sm-10">
        <form className="p-3 bg-white bg-opacity-25 rounded shadow-sm">
          <div className="input-group">
            <div className="w-100">
              <input
                type="text"
                className="form-control"
                placeholder="Rechercher un riad..."
                value={query}
                onChange={(e) => setQuery(e.target.value)}
              />
              <button type="button">
                <i className="ti-search"></i>
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default SearchBarProject;
